const strainprintImages = [
  require('./demo1.png'),
  require('./demo2.png'),
  require('./demo3.png'),
  require('./demo4.png'),
  require('./screen1.png'),
  require('./screen2.png'),
  require('./screen3.png'),
  require('./screen4.png'),
  require('./screen5.png'),
  require('./screen6.png'),
  require('./screen7.png'),
 
   
  ];
  
  export default strainprintImages;